import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import PostCard, { PostPreview } from "./card";

export interface KCTrendingProps {
  posts: PostPreview[];
  color?: string;
}
export const KCTrending = (props: KCTrendingProps) => {
  const trending = props.posts.filter((post) => post.trending);

  return trending?.length > 0 ? (
    <Box
      bgColor="#0A66C2"
      borderRadius={20}
      w="100%"
      pb={{
        base: 10,
        lg: 0,
      }}
      h={{
        base: "100%",
        lg: "350px",
      }}
      mb={{
        base: 0,
        lg: "550px",
      }}
    >
      <Heading
        mt={20}
        textAlign="center"
        zIndex="1"
        position="relative"
        top={9}
        color="white"
      >
        Trending Topics
      </Heading>
      <SimpleGrid
        justifyContent="center"
        mt={20}
        columns={{ base: 1, lg: 3 }}
        spacing="14"
        px={{ base: "6", md: "8" }}
      >
        {trending.map((post, i) => (
          <PostCard key={i} {...{ post, num: i }} color={props?.color} />
        ))}
      </SimpleGrid>
    </Box>
  ) : (
    <></>
  );
};
